import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import React, { FC, useEffect, useState, useCallback, useRef } from 'react'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { Link } from 'react-router-dom'
import { useMutation, useQueryClient } from 'react-query'
import { KTCard, toAbsoluteUrl } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG } from '../../_metronic/helpers'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Maintable } from '../tables/Maintable'
import { Updateproduct } from './modals/Updateproduct'
import { useMemo } from 'react'
import { Addproduct } from './modals/Addproduct'
import { Deleteproduct } from './modals/Deleteproduct'
import { Addstock } from './modals/Addstock'
import { BulkStockImport } from './modals/BulkStockImport'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { getProduct3 } from '../apis/Loadalltabledata'
import { useAllproducts, useSumstock, useVariance, useDeleteproduct, useAllproductsandtypes } from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import LoadingBar from 'react-top-loading-bar'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';
import io from 'socket.io-client'
import { useDashboard } from '../contextProviders/Dashboardcontext'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);


const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const TARGET_SALES = process.env.REACT_APP_TARGET_STOCK_SALES
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const socket = io('possocket.27mirrors.com')

function isNegative(num: any) {
  if (Math.sign(num) === -1) {
    return true
  }

  return false
}
const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Products',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

interface ProductData {
  product_id: number;
  product_name: string;
  units_in_stock: number;
  unit_buying_price: number;
  discount_percentage: number;
  reorder_level: number;
  user_id: number;
  product_category_id: number;
  product_unit_id: number;
  unit_selling_price: number;
  product_description: string;
  product_image: string;
  category_name: string;
  unit_name: string;
  product_division: number;
}

interface CategoryBreakdown {
  [key: string]: {
    count: number;
    totalValue: number;
    totalStock: number;
  };
}

interface ProductWithStockValue extends ProductData {
  stockValue: number;
}

interface StockAnalysis {
  totalProducts: number;
  totalStockValue: number;
  totalSellingValue: number;
  lowStockItems: ProductData[];
  outOfStockItems: ProductData[];
  highValueItems: ProductData[];
  categoryBreakdown: CategoryBreakdown;
  averageMargin: number;
  topPerformers: ProductWithStockValue[];
  riskItems: ProductData[];
}

const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const truncate = require('truncate')

const Home = () => {

  const inputRef: any = useRef(null)
  const [time, setTime] = useState<number>(0)
  const queryClientproducts = useQueryClient()
  const refloadingbar: any = useRef(null)
  const myRef: any = useRef()
  const myRefsearch: any = useRef()
  const { currentUser, logout } = useAuth()
  const [productData, setProductData] = useState<any>([])
  const [table1Dataloaded, settable1Dataloaded] = useState(false)
  const [modalshow, setModalshow] = useState(false)
  const [modalstockshow, setModalstockshow] = useState(false)
  const [modalbulkimportshow, setModalbulkimportshow] = useState(false)
  const [modalproductupdateshow, setModalproductupdateshow] = useState(false)
  const [salesData, setsalesData] = useState<any>([])
  const [salesDataloaded, setsalesDataloaded] = useState(false)
  const [currentsearchItems, setCurrentsearchItems] = useState<string>('')
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>(['product_id', 'product_description'])
  const columndata2 = useMemo(() => [], [])
  const tablename = 'Product Description'
  const [loadedProducts_unit, setLoadedProducts_unit] = useState(false)
  const [products_unit, setProducts_unit] = useState<any>([])
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [loadedProducts_category, setLoadedProducts_category] = useState(false)
  const [products_category, setProducts_category] = useState<any>([])
  const [statedeletingproduct, setStatedeletingproduct] = useState(false)
  const [producttodelete, setProducttodelete] = useState<any>([])
  const [producttoupdate, setProducttoupdate] = useState<any>([])
  const [cannotDeleteproduct, setCannotDeleteproduct] = useState<boolean>(false)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [variancedatanew, setVariancedatanew] = useState<any>([])

  const [sumstockdatanewlivestock, setSumstockdatanewlivestock] = useState<any>([])
  const [sumstockdatanewsnapshotstock, setSumstockdatanewsnapshotstock] = useState<any>([])
  const [sumproductchanges, setSumproductchanges] = useState<any>([])
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimitsumdash, setStartlimitsumdash] = useState<number>(0)
  const [database_limitsumdash, setDatabase_limitsumdash] = useState<number>(7)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [itemto_order, setItemto_order] = useState<string>('product_name')
  const [desorasc, setDesorasc] = useState<string>('ASC')
  const [serversort, setServersort] = useState<any>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false);
  const onlyWidth = useWindowWidth()
  const { showDashboard, toggleDashboard } = useDashboard();


  const {
    isLoading: allproductsloading,
    isSuccess: allproductssuccess,
    data: allproductsdata,
    status: allproductsstatus,
    isPreviousData: allproductspreviousdata,
    isRefetching: allproductsrefetching,
    refetch: allproductsrefetch

  } = useAllproducts(
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item)



  const { mutateAsync: deleteproductsmutateAsync } = useDeleteproduct(producttodelete.product_id)
  const downloadReport = async (): Promise<void> => {
    try {
      await refloadingbar.current?.continuousStart();
      await allproductsandtypesrefetch();
  
      if (!allproductsandtypesdata?.data) {
        console.log('No stock data available to export');
        return;
      }
  
      // Sort products alphabetically by product name
      const allProducts = allproductsandtypesdata.data.sort((a: ProductData, b: ProductData) => 
        (a.product_name || '').localeCompare(b.product_name || '')
      );
  
      // Perform data analysis
      const analysis: StockAnalysis = {
        totalProducts: allProducts.length,
        totalStockValue: allProducts.reduce((sum: number, product: ProductData) =>
          sum + ((Number(product.units_in_stock) || 0) * (Number(product.unit_buying_price) || 0)), 0),
        totalSellingValue: allProducts.reduce((sum: number, product: ProductData) =>
          sum + ((Number(product.units_in_stock) || 0) * (Number(product.unit_selling_price) || 0)), 0),
        lowStockItems: allProducts.filter((product: ProductData) =>
          (Number(product.units_in_stock) || 0) <= (Number(product.reorder_level) || 0) &&
          (Number(product.units_in_stock) || 0) > 0),
        outOfStockItems: allProducts.filter((product: ProductData) =>
          (Number(product.units_in_stock) || 0) === 0),
        highValueItems: allProducts.filter((product: ProductData) =>
          ((Number(product.units_in_stock) || 0) * (Number(product.unit_selling_price) || 0)) > 10000),
        categoryBreakdown: {} as CategoryBreakdown,
        averageMargin: 0,
        topPerformers: [],
        riskItems: []
      };
  
      // Category analysis and calculations
      allProducts.forEach((product: ProductData) => {
        const category: string = product.category_name || 'Uncategorized';
        if (!analysis.categoryBreakdown[category]) {
          analysis.categoryBreakdown[category] = {
            count: 0,
            totalValue: 0,
            totalStock: 0
          };
        }
        analysis.categoryBreakdown[category].count++;
        analysis.categoryBreakdown[category].totalValue +=
          (Number(product.units_in_stock) || 0) * (Number(product.unit_selling_price) || 0);
        analysis.categoryBreakdown[category].totalStock += (Number(product.units_in_stock) || 0);
      });
  
      const totalMargin: number = allProducts.reduce((sum: number, product: ProductData) => {
        const buyingPrice = Number(product.unit_buying_price) || 0;
        const sellingPrice = Number(product.unit_selling_price) || 0;
        const margin = sellingPrice > 0 ? ((sellingPrice - buyingPrice) / sellingPrice) * 100 : 0;
        return sum + margin;
      }, 0);
      analysis.averageMargin = totalMargin / allProducts.length;
  
      analysis.topPerformers = allProducts
        .map((product: ProductData): ProductWithStockValue => ({
          ...product,
          stockValue: (Number(product.units_in_stock) || 0) * (Number(product.unit_selling_price) || 0)
        }))
        .sort((a: ProductWithStockValue, b: ProductWithStockValue) => b.stockValue - a.stockValue)
        .slice(0, 10);
  
      const wb = XLSX.utils.book_new();
  
      // SHEET 1: Stock Data
      const stockData = allProducts.map((product: ProductData) => {
        const stockBuyingValue: number = (Number(product.units_in_stock) || 0) * (Number(product.unit_buying_price) || 0);
        const stockSellingValue: number = (Number(product.units_in_stock) || 0) * (Number(product.unit_selling_price) || 0);
        const buyingPrice = Number(product.unit_buying_price) || 0;
        const sellingPrice = Number(product.unit_selling_price) || 0;
        const margin: number = sellingPrice > 0 ? ((sellingPrice - buyingPrice) / sellingPrice) * 100 : 0;
        const stock = Number(product.units_in_stock) || 0;
        const reorderLevel = Number(product.reorder_level) || 0;
  
        let stockStatus: string = 'Normal';
        if (stock === 0) stockStatus = 'Out of Stock';
        else if (stock <= reorderLevel) stockStatus = 'Low Stock';
  
        return {
          'Product ID': product.product_id || '',
          'Product Name': product.product_name || '',
          'Category': product.category_name || '',
          'Unit': product.unit_name || '',
          'Units in Stock': stock,
          'Buying Price': buyingPrice,
          'Selling Price': sellingPrice,
          'Stock Buying Value': stockBuyingValue,
          'Stock Selling Value': stockSellingValue,
          'Margin %': margin / 100,
          'Discount %': (Number(product.discount_percentage) || 0) / 100,
          'Reorder Level': reorderLevel,
          'Stock Status': stockStatus,
          'Division': product.product_division || '',
          'Description': (product.product_description || '').substring(0, 100)
        };
      });
  
      const wsStock = XLSX.utils.json_to_sheet(stockData);
      XLSX.utils.book_append_sheet(wb, wsStock, "Stock Data");
  
      // SHEET 2: Executive Summary
      const summaryData = [
        { 'Metric': 'Report Generated', 'Value': dayjs().format('YYYY-MM-DD HH:mm:ss') },
        { 'Metric': 'Total Products', 'Value': analysis.totalProducts },
        { 'Metric': 'Total Stock Buying Value', 'Value': analysis.totalStockValue },
        { 'Metric': 'Total Stock Selling Value', 'Value': analysis.totalSellingValue },
        { 'Metric': 'Potential Profit', 'Value': analysis.totalSellingValue - analysis.totalStockValue },
        { 'Metric': 'Average Margin', 'Value': analysis.averageMargin / 100 },
        { 'Metric': 'Low Stock Items', 'Value': analysis.lowStockItems.length },
        { 'Metric': 'Out of Stock Items', 'Value': analysis.outOfStockItems.length },
        { 'Metric': 'High Value Items', 'Value': analysis.highValueItems.length }
      ];
  
      const wsSummary = XLSX.utils.json_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(wb, wsSummary, "Executive Summary");
  
      // SHEET 3: Category Analysis
      if (Object.keys(analysis.categoryBreakdown).length > 0) {
        const categoryData = Object.entries(analysis.categoryBreakdown).map(([category, data]) => ({
          'Category': category,
          'Product Count': data.count,
          'Total Stock Value': data.totalValue,
          'Total Stock Units': data.totalStock,
          'Avg Value per Product': data.totalValue / data.count
        }));
  
        const wsCategory = XLSX.utils.json_to_sheet(categoryData);
        XLSX.utils.book_append_sheet(wb, wsCategory, "Category Analysis");
      }
  
      // SHEET 4: Top Performers
      if (analysis.topPerformers.length > 0) {
        const topPerformersData = analysis.topPerformers.map((product, index) => ({
          'Rank': index + 1,
          'Product Name': product.product_name,
          'Category': product.category_name,
          'Stock Value': product.stockValue,
          'Units in Stock': product.units_in_stock,
          'Selling Price': product.unit_selling_price
        }));
  
        const wsTopPerformers = XLSX.utils.json_to_sheet(topPerformersData);
        XLSX.utils.book_append_sheet(wb, wsTopPerformers, "Top Performers");
      }
  
      // SHEET 5: Stock Alerts
      if (analysis.lowStockItems.length > 0 || analysis.outOfStockItems.length > 0) {
        const alertsData = [
          ...analysis.outOfStockItems.map(product => ({
            'Alert Type': 'OUT OF STOCK',
            'Product Name': product.product_name || '',
            'Category': product.category_name || '',
            'Current Stock': Number(product.units_in_stock) || 0,
            'Reorder Level': Number(product.reorder_level) || 0,
            'Shortage': (Number(product.reorder_level) || 0) - (Number(product.units_in_stock) || 0)
          })),
          ...analysis.lowStockItems.map(product => ({
            'Alert Type': 'LOW STOCK',
            'Product Name': product.product_name || '',
            'Category': product.category_name || '',
            'Current Stock': Number(product.units_in_stock) || 0,
            'Reorder Level': Number(product.reorder_level) || 0,
            'Shortage': (Number(product.reorder_level) || 0) - (Number(product.units_in_stock) || 0)
          }))
        ];
  
        const wsAlerts = XLSX.utils.json_to_sheet(alertsData);
        XLSX.utils.book_append_sheet(wb, wsAlerts, "Stock Alerts");
      }
  
      // Generate Excel file without styling
      const excelBuffer = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      });
  
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
  
      const link: HTMLAnchorElement = document.createElement('a');
      const url: string = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `stock_report_${dayjs().format('YYYY-MM-DD_HH-mm')}.xlsx`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error('Error generating stock report:', error);
    } finally {
      refloadingbar.current?.complete();
    }
  };
  const {
    isLoading: varianceloading,
    isSuccess: variancesuccess,
    data: variancedata,
    status: variancestatus,
    isPreviousData: variancepreviousdata,
    isRefetching: variancerefetching,
    refetch: variancerefetch

  } = useVariance(
    Number(currentUser?.user_id),
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('month').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(
        dayjs(dayjs().add(1, 'M').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).unix()
      )
      .format('YYYY-MM-DD hh:mm')),
    startlimitsumdash,
    database_limitsumdash
  )

  const {
    isLoading: allproductsandtypesloading,
    isSuccess: allproductsandtypessuccess,
    data: allproductsandtypesdata,
    refetch: allproductsandtypesrefetch,
  } = useAllproductsandtypes()
  const {
    isLoading: sumstockloading,
    isSuccess: sumstocksuccess,
    data: sumstockdata,
    status: sumstockstatus,
    isPreviousData: sumstockpreviousdata,
    isRefetching: sumstockrefetching,
    refetch: sumstockrefetch

  } = useSumstock(
    startlimitsumdash,
    database_limitsumdash,
    new Date(dayjs
      .unix(dayjs(dayjs().startOf('month').format('YYYY-MM-DD') + OPENING_TIME).unix())
      .format('YYYY-MM-DD hh:mm')),
    new Date(dayjs
      .unix(
        dayjs(dayjs().add(1, 'M').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).unix()
      )
      .format('YYYY-MM-DD hh:mm'))
  )



  useEffect(() => {
    if (!allproductspreviousdata) {

      queryClientproducts.prefetchQuery(
        ['allproducts', startlimit + paginationsize, paginationsize],
        () =>
          getProduct3(
            startlimit + paginationsize,
            paginationsize,
            itemto_order,
            desorasc,
            search_item
          )
      )
    }
  }, [
    allproductspreviousdata,
    startlimit,
    paginationsize,
    queryClientproducts,
    itemto_order,
    desorasc,
    search_item,
  ])



  const tabledata = useMemo(() => allproductsdata?.data.allproducts, [allproductsdata?.data.allproducts, allproductssuccess])


  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart();
        await allproductsrefetch();
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete();
      }
    };
    fetchData();
  }, [itemto_order, desorasc, search_item]);

  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setItemto_order('product_name')
        setMovetofirstpage(true);
        setDesorasc('ASC')
      }
    }

    const refSearch = myRefsearch.current;
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange);
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange);
      }
    }
  }, []);



  useEffect(() => {


    if (!variancerefetching && variancesuccess) {
      if (dayjs(dayjs(variancedata?.data.sort((a: any, b: any) => (a.date_taken > b.date_taken ? -1 : 1)).map((x: any) => x.date_taken)[0]).format('YYYY-MM-DD')).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()) {
        setVariancedatanew(variancedata?.data)
      }
      else {
        if (dayjs(dayjs(variancedata?.data.sort((a: any, b: any) => (a.date_taken > b.date_taken ? -1 : 1)).map((x: any) => x.date_taken)[0]).format('YYYY-MM-DD')).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format("YYYY-MM-DD, h:mm:ss a")).unix() <= dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()) {

          setVariancedatanew(variancedata?.data)
        }
        else {
          const currentitemsobj2: any = {
            date_taken: dayjs().format('YYYY-MM-DD'),
            buying_price_variance: 0,
            selling_price_variance: 0
          }

          setVariancedatanew([...variancedata?.data, currentitemsobj2])

        }

      }
    }
  }, [variancerefetching, variancesuccess])









  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('product_name')
      setDesorasc('ASC')
    }
  }, [serversort])


  useEffect(() => {
    if (sumstocksuccess && variancesuccess) {
      setStatusnow(true)
    }
  }, [sumstocksuccess, variancesuccess])

  useEffect(() => {
    if (
      statusnow &&
      !sumstockrefetching && !variancerefetching
    ) {
      setStatusnow2(true)
    }
  }, [sumstockrefetching, variancerefetching])

  useEffect(() => {
    if (!sumstockrefetching && sumstocksuccess) {
      setSumstockdatanewlivestock(sumstockdata?.data.livestock)
      setSumstockdatanewsnapshotstock(sumstockdata?.data.snapshotstock)
    }

  }, [sumstocksuccess, sumstockrefetching])

  const deleteselectedproduct = async () => {
    setStatedeletingproduct(true)
    setCannotDeleteproduct(false)
    deleteproductsmutateAsync(producttodelete.product_id, {
      onSuccess: () => {
        setStatedeletingproduct(false)
        setModalshowdelete(false)

      },
      onError(error, variables, context) {
        console.log(error)
        setStatedeletingproduct(false)
        setCannotDeleteproduct(true)

      },
    })
  }


  const showModaldelete = (x: any) => {
    setModalshowdelete(true)
    setStatedeletingproduct(false)
    setCannotDeleteproduct(false)
    setProducttodelete(x)
  }

  const filteredsubdata = (rowdata: any): any => {
    return null;
  }
  const filteredtablesubData = (rowdata: any): any => {

    return rowdata.values.product_description
  }


  const tabledatalength = useMemo(
    () => allproductsdata?.data.allproductslength,
    [allproductsdata?.data.allproductslength, allproductssuccess]
  )

  const showModal = () => {
    setModalshow(true)
  }

  const showproductupdateModal = (x: any) => {
    setProducttoupdate(x)
    setModalproductupdateshow(true)
  }

  const showstockModal = () => {
    setModalstockshow(true)
  }

  const handlesearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      const inputValue = event.target.value;
      if (inputValue) {
        setSearch_item(inputValue + '%');
      } else {
        setSearch_item('%');
      }
      setPaginationsize(10);
      setStartlimit(0);
      setItemto_order('product_name');
      setMovetofirstpage(true);
      setDesorasc('ASC');
    };
  }

  const handlesearchKeyDown2 = (event: any) => {
    event.preventDefault();

    const inputValue = myRefsearch.current.value || event.target.value;
    if (inputValue) {
      setSearch_item(inputValue + '%');
    } else {
      setSearch_item('%');
    }

    setPaginationsize(10);
    setStartlimit(0);
    setItemto_order('product_name');
    setMovetofirstpage(true);
    setDesorasc('ASC');
  }



  const handleinputs = (event: any) => {

    if (event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('product_name')
      setMovetofirstpage(true);
      setDesorasc('ASC')
    }
  }



  socket.on('update', (_arg: any) => {
    ; (async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await allproductsrefetch()
        await variancerefetch()
        await sumstockrefetch()

      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })


  const columndata1: ReadonlyArray<
    Column<{
      product_id: number
      product_name: string
      units_in_stock: number
      unit_buying_price: number
      discount_percentage: number
      reorder_level: number
      user_id: number
      product_category_id: number
      product_unit_id: number
      unit_selling_price: number
      product_description: string
      product_image: string
      category_name: string
      unit_name: string
      product_division: number


    }>
  > = [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Name',
        accessor: 'product_name', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {

          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-50px me-5'>
                <div className='symbol-label bg-light'>
                  <img
                    src={toAbsoluteUrl('/media/products/' + row.original.product_image)}
                    alt=''
                    className='h-100'
                  />
                </div>
              </div>


              <div className='d-flex justify-content-start flex-column'>
                <>
                  <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.product_name}>{truncate(row.original.product_name, 20)}
                    <span className='h-10px border-gray-200 border-start mx-2'></span>
                    <span className='text-success fw-bolder text-hover-success fs-6'>
                      {row.original.product_division}
                    </span>
                  </span>

                  <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                    {addCommas(row.original.units_in_stock)}{' '}
                    <span className='me-1'>{row.original.unit_name} </span> <span className='badge badge-light-dark me-1'>
                      {truncate(row.original.category_name, 20)}
                    </span>
                  </span>
                </>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'product_description',
        accessor: 'product_description',

      },
      {
        Header: 'B.Price',
        accessor: 'unit_buying_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.product_name}>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Discount: {addCommas(row.original.discount_percentage)}%
            </span>
          </>
        ),
      },
      {
        Header: 'S.Price',
        accessor: 'unit_selling_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap' title={row.original.product_name}>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              R.Level: {addCommas(row.original.reorder_level)}
            </span>
          </>
        ),
      },
      {
        Header: 'id',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap' title={row.original.product_name}>
              {value}
            </span>

          </>
        ),
      },
      {
        Header: 'S.Key',
        accessor: 'units_in_stock',

        Cell: ({ cell: { value }, row }) => (
          <>

            <span className='text-dark fw-bolder d-block mb-1 fs-7 text-nowrap' title={row.original.product_name}>
              <span className='badge badge-light-dark me-1'>
                {"00" + row.original.product_id}
              </span>
              {' '}
              <sup className='text-danger'>
                {isNegative(row.original.units_in_stock - row.original.reorder_level) ? (row.original.units_in_stock - row.original.reorder_level) : ""}
              </sup>
            </span>

          </>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                onClick={() => showproductupdateModal(row.original)}>
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                onClick={() => showModaldelete(row.original)}
              >
                {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </a>
            </div>
          )
        },
      },
    ]


  const columndata3: ReadonlyArray<
    Column<{
      product_id: number
      product_name: string
      units_in_stock: number
      unit_buying_price: number
      discount_percentage: number
      reorder_level: number
      user_id: number
      product_category_id: number
      product_unit_id: number
      unit_selling_price: number
      product_description: string
      product_image: string
      category_name: string
      unit_name: string
      product_division: number

    }>
  > = [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'product_description',
        accessor: 'product_description',

      },
      {
        Header: 'Name',
        accessor: 'product_name', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {

          return (
            <div className='d-flex align-items-center'>

              <div className='d-flex justify-content-start flex-column'>
                <>
                  <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.product_name}>{truncate(row.original.product_name, 15)}

                  </span>

                  <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                    {addCommas(row.original.units_in_stock)}{' '}
                    <span className='me-1'>{row.original.unit_name}</span> <span className='badge badge-light-dark me-1'>
                      {truncate(row.original.category_name, 20)}
                    </span>
                  </span>
                </>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'id',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap' title={row.original.product_name}>
              {value}
            </span>

          </>
        ),
      },

      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                onClick={() => showproductupdateModal(row.original)}>
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                onClick={() => showModaldelete(row.original)}
              >
                {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </a>
            </div>
          )
        },
      },
    ]

  const columndata5: ReadonlyArray<
    Column<{
      product_id: number
      product_name: string
      units_in_stock: number
      unit_buying_price: number
      discount_percentage: number
      reorder_level: number
      user_id: number
      product_category_id: number
      product_unit_id: number
      unit_selling_price: number
      product_description: string
      product_image: string
      category_name: string
      unit_name: string
      product_division: number

    }>
  > = [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Name',
        accessor: 'product_name', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {

          return (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-50px me-5'>
                <div className='symbol-label bg-light'>
                  <img
                    src={toAbsoluteUrl('/media/products/' + row.original.product_image)}
                    alt=''
                    className='h-100'
                  />
                </div>
              </div>


              <div className='d-flex justify-content-start flex-column'>
                <>
                  <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap'>{truncate(row.original.product_name, 20)}
                    <span className='h-10px border-gray-200 border-start mx-2'></span>
                    <span className='text-success fw-bolder text-hover-success fs-6'>
                      {row.original.product_division}
                    </span>
                  </span>

                  <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                    {addCommas(row.original.units_in_stock)}{' '}
                    <span className='me-1'>{row.original.unit_name} </span> <span className='badge badge-light-dark me-1'>
                      {truncate(row.original.category_name, 20)}
                    </span>
                  </span>
                </>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'product_description',
        accessor: 'product_description',

      },
      {
        Header: 'B.Price',
        accessor: 'unit_buying_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Discount: {addCommas(row.original.discount_percentage)}%
            </span>
          </>
        ),
      },
      {
        Header: 'S.Price',
        accessor: 'unit_selling_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              R.Level: {addCommas(row.original.reorder_level)}
            </span>
          </>
        ),
      },
      {
        Header: 'id',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap'>
              {value}
            </span>

          </>
        ),
      },

      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              <a className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                onClick={() => showproductupdateModal(row.original)}>
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      opacity='0.3'
                      d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                      fill='black'
                    ></path>
                    <path
                      d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                      fill='black'
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                onClick={() => showModaldelete(row.original)}
              >
                {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                <span className='svg-icon svg-icon-3'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                      fill='#f1416c'
                    />
                    <path
                      opacity='0.5'
                      d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                      fill='#f1416c'
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </a>
            </div>
          )
        },
      },
    ]
  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Product list</PageTitle>
      {/* begin::Row */}
      {showDashboard && (
      <div className='row g-5 g-xl-8'>
        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='120px'
            cardName='B.Price'
            chartName='Stock Buying Price'
            statusnow={statusnow}
            statusnow2={statusnow2}
            yaxisHeight={Math.abs(Math.max(...sumstockdatanewsnapshotstock.map((x: any) => x.stock_buying_price)))}
            chartCategories={sumstockdatanewsnapshotstock
              .sort((a: any, b: any) => (a.date_taken > b.date_taken ? 1 : -1))
              .map((x: any) => dayjs(x.date_taken).format('LL'))}
            chartData={sumstockdatanewsnapshotstock
              .sort((a: any, b: any) => (a.date_taken > b.date_taken ? 1 : -1))
              .map((x: any) => x.stock_buying_price)}
            values={<>
              <div className='fs-2 fw-bolder d-block '>
                <CountUp
                  className='text-primary'
                  end={sumstockdatanewlivestock.map((x: any) => x.stock_buying_price)[0]}
                  duration={2}
                  decimals={2}
                  separator=',' />{' '}
                <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
              </div>
            </>}
            values2={<>
              <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                <table>

                  <tbody>
                    {sumstockdatanewsnapshotstock
                      .sort((a: any, b: any) =>
                        a.date_taken > b.date_taken ? -1 : 1
                      )
                      .map((x: any) => x.date_taken)[1] ? (
                      <tr>
                        <td>
                          <span className='badge badge-light-primary'>
                            {dayjs(
                              sumstockdatanewsnapshotstock
                                .sort((a: any, b: any) =>
                                  a.date_taken > b.date_taken ? -1 : 1
                                )
                                .map((x: any) => x.date_taken)[1]
                            ).calendar(null, {
                              sameDay: '[Today]',
                              nextDay: '[Tomorrow]',
                              nextWeek: 'dddd',
                              lastDay: '[Yesterday]',
                              lastWeek: 'dddd',
                              sameElse: 'DD/MM/YYYY',
                            })}
                          </span>
                        </td>
                        <td>
                          <span className='h-20px border-gray-200 border-start mx-2'></span>
                          <CountUp
                            className='text-bold text-muted'
                            end={
                              sumstockdatanewsnapshotstock
                                .sort((a: any, b: any) =>
                                  a.date_taken > b.date_taken ? -1 : 1
                                )
                                .map((x: any) => x.stock_buying_price)[1]
                            }
                            duration={2}
                            decimals={2}
                            separator=','
                          />{' '}
                          <sup className='text-muted'>{CURRENCY_APP}</sup>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}

                    {sumstockdatanewsnapshotstock
                      .sort((a: any, b: any) =>
                        a.date_taken > b.date_taken ? -1 : 1
                      )
                      .map((x: any) => x.date_taken)[2] ? (
                      <tr>
                        <td>
                          <span className='badge badge-light-primary'>
                            {dayjs(
                              sumstockdatanewsnapshotstock
                                .sort((a: any, b: any) =>
                                  a.date_taken > b.date_taken ? -1 : 1
                                )
                                .map((x: any) => x.date_taken)[2]
                            ).calendar(null, {
                              sameDay: '[Today]',
                              nextDay: '[Tomorrow]',
                              nextWeek: 'dddd',
                              lastDay: '[Yesterday]',
                              lastWeek: 'dddd',
                              sameElse: 'DD/MM/YYYY',
                            })}
                          </span>
                        </td>
                        <td>
                          <span className='h-20px border-gray-200 border-start mx-2'></span>
                          <CountUp
                            className='text-bold text-muted'
                            end={
                              sumstockdatanewsnapshotstock
                                .sort((a: any, b: any) =>
                                  a.date_taken > b.date_taken ? -1 : 1
                                )
                                .map((x: any) => x.stock_buying_price)[2]
                            }
                            duration={2}
                            decimals={2}
                            separator=','
                          />{' '}
                          <sup className='text-muted'>{CURRENCY_APP}</sup>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </tbody>

                </table>
              </span>
            </>} />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-xl-8'
            chartColor='primary'
            chartHeight='120px'
            cardName='S.Price'
            chartName='Stock Selling Price'
            statusnow={statusnow}
            statusnow2={statusnow2}
            yaxisHeight={Math.abs(Math.max(...sumstockdatanewsnapshotstock.map((x: any) => x.stock_selling_price)))}
            chartCategories={sumstockdatanewsnapshotstock
              .sort((a: any, b: any) => (a.date_taken > b.date_taken ? 1 : -1))
              .map((x: any) => dayjs(x.date_taken).format('LL'))}
            chartData={sumstockdatanewsnapshotstock
              .sort((a: any, b: any) => (a.date_taken > b.date_taken ? 1 : -1))
              .map((x: any) => x.stock_selling_price)}
            values={
              <div className='fs-2 fw-bolder'>
                <CountUp
                  className='text-primary'
                  end={sumstockdatanewlivestock.map((x: any) => x.stock_selling_price)[0]}
                  duration={2}
                  decimals={2}
                  separator=','
                />{' '}
                <sup className='text-primary fs-6'>{CURRENCY_APP}</sup>
              </div>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {sumstockdatanewsnapshotstock
                        .sort((a: any, b: any) =>
                          a.date_taken > b.date_taken ? -1 : 1
                        )
                        .map((x: any) => x.date_taken)[1] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(
                                sumstockdatanewsnapshotstock
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.date_taken)[1]
                              ).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={
                                sumstockdatanewsnapshotstock
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.stock_selling_price)[1]
                              }
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {sumstockdatanewsnapshotstock
                        .sort((a: any, b: any) =>
                          a.date_taken > b.date_taken ? -1 : 1
                        )
                        .map((x: any) => x.date_taken)[2] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(
                                sumstockdatanewsnapshotstock
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.date_taken)[2]
                              ).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={
                                sumstockdatanewsnapshotstock
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.stock_selling_price)[2]
                              }
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>

                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xl-4'>
          <ItemsSummary
            className='card-xl-stretch mb-5 mb-xl-8'
            chartColor={"info"}
            chartHeight='120px'
            statusnow={statusnow}
            statusnow2={statusnow2}
            cardName={"Var."}
            chartName={"Stock Variance"}
            yaxisHeight={Math.abs(Math.max(...variancedatanew.map((x: any) => x.buying_price_variance)))}
            chartCategories={variancedatanew
              .sort((a: any, b: any) => (a.date_taken > b.date_taken ? 1 : -1))
              .map((x: any) => dayjs(x.date_taken).format('LL'))}
            chartData={variancedatanew
              .sort((a: any, b: any) => (a.date_taken > b.date_taken ? 1 : -1))
              .map((x: any) => x.buying_price_variance)}
            values={
              <>
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className={`text-info`}
                    end={variancedatanew.sort((a: any, b: any) => (a.date_taken > b.date_taken ? -1 : 1)).map((x: any) => x.buying_price_variance)[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup
                    className={'fs-6 text-info'}
                  >
                    {CURRENCY_APP}
                  </sup>
                </div>
              </>
            }
            values2={
              <>
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {variancedatanew
                        .sort((a: any, b: any) =>
                          a.date_taken > b.date_taken ? -1 : 1
                        )
                        .map((x: any) => x.date_taken)[1] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-info'>
                              {dayjs(
                                variancedatanew
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.date_taken)[1]
                              ).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={
                                variancedatanew
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.buying_price_variance)[1]
                              }
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}

                      {variancedatanew
                        .sort((a: any, b: any) =>
                          a.date_taken > b.date_taken ? -1 : 1
                        )
                        .map((x: any) => x.date_taken)[2] ? (
                        <tr>
                          <td>
                            <span className='badge badge-light-info'>
                              {dayjs(
                                variancedatanew
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.date_taken)[2]
                              ).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={
                                variancedatanew
                                  .sort((a: any, b: any) =>
                                    a.date_taken > b.date_taken ? -1 : 1
                                  )
                                  .map((x: any) => x.buying_price_variance)[2]
                              }
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tbody>

                  </table>
                </span>
              </>
            }
          />
        </div>
        {/* end::Col */}
      </div>)}
      {/* end::Row */}
      <KTCard>
        <KTCardBody className='py-4'>

          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Update Product</h3>
              </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>


              <div className='mb-2'>
                {/* begin::Search */}
                <div className='d-flex align-items-center position-relative my-1'>

                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'

                    />
                  </a>

                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-5 pe-12'
                    placeholder='Search Products'
                    ref={myRefsearch}
                    // value={searchTitle}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}

                  />

                </div>
                {/* end::Search */}
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2 me-auto'>
                {/* CSV Download Button - Far Left */}
                <a className='btn btn-info btn-sm mb-2 me-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  downloadReport();
                }}>
                  <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '↓' : 'Download Report'}
                </a>
              </div>

              <div className='mb-2' style={{ display: "inline-grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
                {/* Add Product Button */}
                <a className='btn btn-success btn-sm mb-2 me-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>

                ) => {
                  e.preventDefault();
                  showModal();

                }
                }
                title={onlyWidth <= 576 ? 'Add Product' : ''}>
                  <KTSVG path='/media/icons/duotune/ecommerce/ecm006.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '+' : 'Add Product'}
                </a>

                {/* Add Stock Button */}
                <a className='btn btn-primary btn-sm mb-2 me-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  showstockModal();
                }}
                title={onlyWidth <= 576 ? 'Add Stock' : ''}>
                  <KTSVG path='/media/icons/duotune/general/gen017.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '+' : 'Add Stock'}
                </a>

                {/* Bulk Import Button */}
                <a className='btn btn-light-warning btn-sm mb-2' href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  setModalbulkimportshow(true);
                }}
                title={onlyWidth <= 576 ? 'Bulk Import' : ''}>
                  <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '↑' : 'Bulk Import'}
                </a>
              </div>
            </div>
          </div>
          <Maintable
            tabledata={allproductssuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={hiddencolumnsmade}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={onlyWidth <= 576 ? columndata3 : onlyWidth > 576 && onlyWidth <= 768 ? columndata5 : columndata1}
            tabledata2={tabledata}
            columndata2={columndata2}
            table1loaded={allproductsstatus === 'success'}
            table2loaded={allproductsstatus === 'success'}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            tablename={tablename}
            tablelength={allproductsstatus === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>
      <Addproduct
        show={modalshow}

        handleClose={function (): void {
          setModalshow(false)
        }}
      />


      <Updateproduct
        show={modalproductupdateshow}
        producttoupdate={producttoupdate}
        allproductsrefetch={allproductsrefetch}
        sumstockrefetch={sumstockrefetch}
        variancerefetch={variancerefetch}
        handleClose={function (): void {
          setModalproductupdateshow(false)
        }}
      />

      <Addstock

        show={modalstockshow}
        allproductsrefetch={allproductsrefetch}
        sumstockrefetch={sumstockrefetch}
        variancerefetch={variancerefetch}
        handleClose={function (): void {
          setModalstockshow(false)
        }}
      />

      <BulkStockImport
        show={modalbulkimportshow}
        existingProducts={allproductsandtypesdata?.data ?? []}
        allproductsrefetch={allproductsrefetch}
        sumstockrefetch={sumstockrefetch}
        variancerefetch={variancerefetch}
        handleClose={function (): void {
          setModalbulkimportshow(false)
        }}
      />

      <Deleteproduct
        show={modalshowdelete}

        deleteselectedproduct={deleteselectedproduct}
        producttodelete={producttodelete}
        statedeletingproduct={statedeletingproduct}
        cannotDeleteproduct={cannotDeleteproduct}
        handleClose={function (): void {
          setModalshowdelete(false)
        }}
      />
    </>
  )
}

export default Home
